import styled from 'styled-components';
import theme from '|/components/base/theme';
import AlertTriangle from '|/icons/alert-triangle.svg';

export const AlertIcon = styled(AlertTriangle)`
  & > svg {
    transform: scale(2.2);
  }

  & > svg > g {
    fill: var(--colors-primary-yellow-2);
  }

  height: 55px;
  width: 55px;
  color: var(--colors-primary-yellow-2);
`;

export const BoldText = styled.p`
  color: var(--colors-primary-blue-6);
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 8px;
  margin-top: 24px;
  text-align: center;
`;

export const BodyText = styled.p`
  margin: 0;
  ${theme.font.body.m}
  color: var(--colors-neutral-gray-5);
  text-align: center;
`;

export const ButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  flex-direction: column;
  margin-top: 40px;

  @media (min-width: ${theme.breakpoints.sm}) {
    flex-direction: row;
    justify-content: center;
    gap: 14px;
  }
`;

export const OptionsWrapper = styled.div`
  align-items: left;
  margin-top: 20px;
  width: 100%;

  @media (min-width: ${theme.breakpoints.sm}) {
    width: 80%;
  }
`;

export const Option = styled.div`
  margin-bottom: 10px;
  color: #183558;
  font-weight: 300;
`;

export const OptionText = styled.div`
  margin-bottom: 10px;
  margin-left: 40px;
`;

export const TextAreaStyle = styled.textarea`
  border: 1px solid lightgrey;
  color: #183558;
  font-weight: 300;
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  resize: none;
`;

export const ContentWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 100px 30px 50px;
  position: relative;

  @media (min-width: ${theme.breakpoints.sm}) {
    padding-top: 50px;
  }
`;
